import { ensureFeatureFlagOnLoader } from '~/feature-flags/utils';
import { k8sQueryGetResource } from '~/k8s';
import { ComponentGroupModel } from '~/models';
import { RouterParams } from '~/routes/utils';
import { createLoaderWithAccessCheck } from '~/utils/rbac';

export const componentGroupDetailsViewLoader = createLoaderWithAccessCheck(
  ({ params }) => {
    ensureFeatureFlagOnLoader('component-model');

    const ns = params[RouterParams.workspaceName];

    return k8sQueryGetResource({
      model: ComponentGroupModel,
      queryOptions: {
        ns,
        name: params[RouterParams.groupName],
      },
    });
  },
  {
    model: ComponentGroupModel,
    verb: 'get',
  },
);

export { default as ComponentGroupDetailsViewLayout } from './ComponentGroupDetailsView';
export { ComponentGroupReleasesTab } from './tabs/ComponentGroupReleasesTab';
export { ComponentGroupIntegrationTestsTab } from './tabs/ComponentGroupIntegrationTestsTab';
export { ComponentGroupComponentsTab } from './tabs/ComponentGroupComponents/ComponentGroupComponentsTab';
export { ComponentGroupPipelineRunsTab } from '~/components/ComponentGroups/ComponentGroupDetails/tabs/ComponentGroupPipelineRunsTab';
